import React from 'react'
import Appointment from '../../components/Doctors/Appointment'
import SlotBooking from '../../components/Doctors/SlotBooking'
const AppointmentPage = () => {
  return (
    <div>
      <Appointment/>
      {/* <SlotBooking/> */}
    </div>
  )
}

export default AppointmentPage
